import { render, staticRenderFns } from "./FacebookBreakdownStats.vue?vue&type=template&id=cb2f68d8"
import script from "./FacebookBreakdownStats.vue?vue&type=script&lang=js"
export * from "./FacebookBreakdownStats.vue?vue&type=script&lang=js"
import style0 from "./FacebookBreakdownStats.vue?vue&type=style&index=0&id=cb2f68d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports